import Vue from "vue";
import {Classified} from "@/shared/interfaces/classified/Classified.interface";
import {Customer} from "@/shared/interfaces/customer/Customer.interface";
import {ApiError} from "@/shared/interfaces/ApiError";
import {ApiErrorWrapper} from "@/shared/interfaces/ApiErrorWrapper";
import { Order } from "../interfaces/order/Order.interface";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { get as dotGet } from "dot-prop";

export function setValueByPath(criteriaObject: Partial<Classified|Customer|Order>, pathString: string, val: string): void {
    const path: Array<string> = pathString.split(".");
    const length = path.length;

    // check if html is present
    if (typeof val === "string" && val.indexOf("<") !== -1) {
        val = val.replace(/(<([^>]+)>)/ig, "");
    }

    path.forEach(function (key: string, index: number) {

        // Check if the assigned key is an array
        const isArray = key.slice(-2) === "[]";

        // If so, get the true key name by removing the trailing []
        key = isArray ? key.slice(0, -2) : key;

        // If the key should be an array and isn't, create an array
        if (isArray && Object.prototype.toString.call(criteriaObject[key]) !== "[object Array]") {
            Vue.set(criteriaObject, key, []);
        }

        // If this is the last item in the loop, assign the value
        if (index === length - 1) {
            // If it's an array, push the value
            // Otherwise, assign it
            if (isArray) {
                Vue.set(criteriaObject[key], criteriaObject[key].length, val);
            } else {
                Vue.set(criteriaObject, key, val);
            }
        }

        // Otherwise, update the current place in the object
        else {

            // If the key doesn't exist, create it
            if (!criteriaObject[key]) {
                Vue.set(criteriaObject, key, {});
            }

            // Update the current place in the object
            criteriaObject = criteriaObject[key];
        }

    });
}

export function getValueByPath(object: Classified | Order, path: string): any {
    return dotGet(object, path, null);
}

export function deleteValueByPath(criteriaObject: Classified, pathString: string): void {
    const path: Array<string> = pathString.split(".");
    const length = path.length;

    for (let i = 0; i < length; i++) {

        // If this is the last item in the loop, delete the value
        if (i === length - 1) {
            Vue.delete(criteriaObject, path[i]);
        }// Otherwise, go deeper
        else {

            // If the key doesn't exist, break out
            if (!criteriaObject[path[i]]) {
                break;
            }
            // Update the current place in the object
            criteriaObject = criteriaObject[path[i]];
        }
    }
}

export function getErrorObjectByPath(errorsObject: ApiErrorWrapper|null, path: string): string|null {
    if (!errorsObject) {
        return null;
    }

    let matchingError: ApiError|null = null;
    const errorArray = errorsObject.warnings;
    for (let i = 0; i < errorArray.length; i++) {
        if (errorArray[i].property == path) {
            matchingError = errorArray[i];
            break;
        }
    }

    if (matchingError && matchingError.type) {
        return i18n.t(matchingError.type) as string;
    }
    return null;
}
